export default class ApiConstant {
  static readonly LoginAuth = '/api/Authenticate/Login';
  static readonly GetMySettings = '/api/Users/GetSettings';
  static readonly SetMySettings = '/api/Users/SetSettings';
  static readonly GetAssignedSpace = '/api/Users/GetAssignedSpace';
  static readonly GetMySettingsBasic = '/api/Users/GetSettingsBasic';
  static readonly GetWorklocation = '/api/Users/GetWorkPlaces';
  static readonly SetWorklocation = '/api/Users/SetWorkPlaces';
  static readonly SetAssignedSpaceAvailablity = '/api/Users/SetAssignedSpaceAvailability';
  static readonly GetWorkPlacesList = '/api/users/GetWorkPlacesList';
  static readonly GetTeamWorkPlaces = '/api/Users/TeamWorkPlaces';
  static readonly LogOut = '/Account/APILogout';

  //V2 Dev
  //Get Language translation file
  static readonly GetLanguageInfo = '/api/WorkPlaces/GetLanguageInfo/';
  static readonly GetLoginLanguageInfo = '/api/WorkPlaces/GetLoginLanguageInfo/';
  //Get all space types for a location
  static readonly GetResourceSpaceTypeList = '/api/WorkPlaces/GetResourceSpaceTypeList';
  //Get all User bookings by date
  static readonly GetUserBookings = '/api/WorkPlaces/GetUserBookings';
  //Booking Actions
  static readonly BookingCheckIn = '/api/QKioskMobile/CheckIn';
  static readonly BookingCheckOut = '/api/QKioskMobile/CheckOut';
  static readonly BookingExtend = '/api/QKioskMobile/Extend';
  static readonly BookingCancel = '/api/QKioskMobile/DeleteBooking';
  //Get all tags for a location
  static readonly GetSearchTagsList = '/api/WorkPlaces/GetSearchTagsList';
  //Get all equipments availabe for a location
  static readonly GetResourceEquipmentList = '/api/QKioskMobile/GetResourceEquipmentList';
  //Get all availabe resources by search string, location, keywords etc.
  static readonly GetAvailableResourceList = '/api/WorkPlaces/GetAvailableResourceList';
  //Search Users to add as attendee for create Booking
  static readonly UserSearch = '/api/WorkPlaces/UserSearch';
  //Check if selected resource is available for Booking
  static readonly ResourceAvailabilityCheck = "/api/WorkPlaces/ResourceAvailabilityCheck";
  //Get Resource data for slected Resource
  static readonly GetResourceData = "/api/QKioskMobile/GetResourceData";
  //Create User Booking
  static readonly CreateBooking = '/api/WorkPlaces/CreateBooking';
  //Create Maps data for all location
  static readonly GetMaps = '/api/QKioskMobile/GetMapsV1';
  static readonly GetMapHotspots = '/api/Maps/GetMapHotspots';
}
